import React, { useEffect } from "react";

export function MonitoringChartDataTable({ columns, rows, caption }) {
	if (!columns?.length) return null;

	return (
		<div className="monitoring__expand-table-wrap">
			{caption && <h4 className="monitoring__expand-table-title">{caption}</h4>}
			<div className="monitoring__table-scroll monitoring__expand-table-scroll">
				<table className="monitoring__table">
					<thead>
						<tr>
							{columns.map((col) => (
								<th
									key={col.key}
									scope="col"
									className={col.numeric ? "monitoring__th-num" : undefined}
								>
									{col.label}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{(rows || []).map((row, index) => (
							<tr key={row.id || row.key || index}>
								{columns.map((col) => {
									const value = col.render
										? col.render(row)
										: row[col.key];
									return (
										<td
											key={col.key}
											className={col.numeric ? "monitoring__td-num" : undefined}
										>
											{value}
										</td>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}

export function MonitoringExpandButton({ onClick, label = "Expand" }) {
	return (
		<button
			type="button"
			className="monitoring__expand-btn"
			onClick={onClick}
		>
			{label}
		</button>
	);
}

export default function MonitoringExpandModal({
	open,
	onClose,
	title,
	chart,
	table,
}) {
	useEffect(() => {
		if (!open) return undefined;

		function onKeyDown(event) {
			if (event.key === "Escape") onClose();
		}

		document.addEventListener("keydown", onKeyDown);
		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";

		return () => {
			document.removeEventListener("keydown", onKeyDown);
			document.body.style.overflow = previousOverflow;
		};
	}, [open, onClose]);

	if (!open) return null;

	return (
		<div
			className="monitoring__expand-dialog"
			onClick={onClose}
			role="presentation"
		>
			<div
				className="monitoring__expand-dialog-content"
				onClick={(event) => event.stopPropagation()}
				role="dialog"
				aria-modal="true"
				aria-labelledby="monitoring-expand-title"
			>
				<div className="monitoring__expand-dialog-header">
					<h3 id="monitoring-expand-title" className="monitoring__expand-dialog-title">
						{title}
					</h3>
					<button
						type="button"
						className="monitoring__expand-dialog-close"
						onClick={onClose}
						aria-label="Close"
					>
						×
					</button>
				</div>
				<div className="monitoring__expand-body">
					<div className="monitoring__expand-chart">{chart}</div>
					{table}
				</div>
			</div>
		</div>
	);
}
